import React from "react";
import { Badge } from "@/components/_components/badge";
import { getJobRole } from "../../utils/chatUtils";
import { SessionInfoProps } from "./types";

export const SessionInfo: React.FC<SessionInfoProps> = ({
  transId,
  agentType,
  transMasterData,
  isLoadingTransMaster
}) => {
  const shouldShowSessionInfo = transId || agentType || transMasterData;
  
  if (!shouldShowSessionInfo) {
    return null;
  }

  return (
    <div className="bg-muted/50 p-4 rounded-lg space-y-2 border border-border">
      <h3 className="font-medium text-foreground">Session Information</h3>
      
      {transMasterData?.externalCd && (
        <div className="text-sm">
          <span className="font-medium text-foreground">Job No:</span>
          <span className="ml-2 text-muted-foreground">{transMasterData.externalCd}</span>
        </div>
      )}
      
      {agentType && (
        <div className="text-sm">
          <span className="font-medium text-foreground">Agent Type:</span>
          <span className="ml-2 text-muted-foreground">{agentType}</span>
        </div>
      )}
      
      <div className="text-sm flex items-center">
        <span className="font-medium text-foreground">Role/Title:</span>
        <div className="ml-2">
          {isLoadingTransMaster ? (
            <span className="text-muted-foreground">Loading...</span>
          ) : (
            <Badge
              variant="outline"
              className="bg-primary/10 text-primary border-primary/20 font-medium text-xs"
            >
              {getJobRole(transMasterData?.addDetails || null)}
            </Badge>
          )}
        </div>
      </div>
    </div>
  );
};